import { validateUrl } from '#lib/urlValidation';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates an email address against a simple regex pattern.
 * Empty inputs are considered valid (optional).
 * @param {string|null|undefined} value - Email address to validate
 * @returns {{valid: boolean, error: string|null}}
 */
export function validateEmail(value) {
	if (!value || !value.trim()) return { valid: true, error: null };
	if (EMAIL_REGEX.test(value.trim())) return { valid: true, error: null };
	return { valid: false, error: 'Bitte eine gültige E-Mail-Adresse eingeben' };
}

const URL_FIELD_KEYS = new Set(['linkedinUrl', 'websiteUrl']);
const EMAIL_FIELD_KEYS = new Set(['emailAddress']);

/**
 * Validates a field value based on its field definition.
 * Delegates to validateUrl for URL fields (fieldType 'url' or keys 'linkedinUrl'/'websiteUrl')
 * and to validateEmail for email fields (key 'emailAddress'). All other fields are considered valid.
 * Empty values are always considered valid.
 * @param {Object} def - Field definition
 * @param {string} def.fieldType - Type of the field (e.g. 'url', 'text')
 * @param {string} def.fieldKey - Key of the field (e.g. 'linkedinUrl', 'emailAddress')
 * @param {string|null|undefined} value - Field value to validate
 * @returns {{valid: boolean, normalized: string|null, error: string|null}}
 */
export function validateField(def, value) {
	if (!value || (typeof value === 'string' && !value.trim())) {
		return { valid: true, normalized: null, error: null };
	}

	if (def.fieldType === 'url' || URL_FIELD_KEYS.has(def.fieldKey)) {
		return validateUrl(value);
	}
	if (EMAIL_FIELD_KEYS.has(def.fieldKey)) {
		return validateEmail(value);
	}

	return { valid: true, normalized: null, error: null };
}
